import { FormattedMessage, useIntl } from 'react-intl'
import { Box, TextField, FormHelperText, styled } from '@mui/material'
import { LabelWithIndicator, MenuItem } from '@carto/meridian-ds/components'

const Input = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    '& textarea': {
      minHeight: theme.spacing(12)
    }
  }
}))

interface AppFormBaseFieldOption {
  labelId: string
  value: string | number
}

export interface AppFormBaseFieldProps {
  name: string
  defaultValue?: string | number | undefined
  labelId: string
  placeholderId?: string
  helpTextId?: string
  options?: Array<AppFormBaseFieldOption>
  disabled?: boolean
  multiline?: boolean
  maxLength?: number
  hasErrors?: boolean
  errorMessageId?: string
  optional?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: any
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}

function AppFormBaseField({
  name,
  defaultValue,
  labelId,
  placeholderId,
  helpTextId,
  options,
  disabled,
  multiline,
  maxLength,
  hasErrors,
  errorMessageId,
  optional,
  register,
  onChange
}: AppFormBaseFieldProps) {
  const intl = useIntl()

  return (
    <Box position="relative">
      <Input
        key={name}
        name={name}
        autoComplete="false"
        defaultValue={defaultValue}
        size="small"
        error={hasErrors}
        label={
          <LabelWithIndicator label={<FormattedMessage id={labelId} />} type={optional ? 'optional' : undefined} />
        }
        helperText={hasErrors && <FormattedMessage id={errorMessageId} />}
        inputProps={{
          'aria-label': name,
          ...(maxLength ? { maxLength: maxLength } : {}),
          ...register
        }}
        placeholder={placeholderId ? intl.formatMessage({ id: placeholderId }) : ''}
        onChange={onChange}
        {...(options?.length ? { select: true } : {})}
        {...(disabled ? { disabled: true } : {})}
        {...(multiline ? { multiline: true } : {})}
      >
        {options?.map((fieldOption) => (
          <MenuItem key={fieldOption.labelId} value={fieldOption.value}>
            <FormattedMessage id={fieldOption.labelId} />
          </MenuItem>
        ))}
      </Input>
      <FormHelperText>{helpTextId ? `${intl.formatMessage({ id: helpTextId })} ` : null}</FormHelperText>
    </Box>
  )
}
export default AppFormBaseField
